// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"58a5960f","595":"36256f28","828":"55e0fbc6"}[chunkId] + ".chunk.css";
};